'use strict';

const formHelper = require('../../rituals-form-helper');
const flyout = require('../../flyout');
const giftwrap = require('../../giftwrap.js');
const validatory = require('../../validator');

const genericFlyout = '.js-generic-flyout';
const editShippingFlyoutClass = '.js-flyout-edit-shipping-options';
const editShippingFlyoutCloseClass = '.js-flyout-edit-shipping-options .js-close-flyout';

const selectors = {
    PICKUP_POINT_WRAPPER: '.js-edit-pickup-points-wrapper',
    PICKUP_IN_STORE_FLYOUT_WRAPPER: '.js-edit-pickup-in-store-wrapper',
    PICKUP_FLYOUT_RADIO_BUTTON: '.js-select-pickup-radio',
    PICKUP_IN_STORE_FLYOUT_ROW: '.js-pickup-in-store-row',
    SHIPPING_OPTIONS_CONTAINER: '.js-shipping-options-container',
    PICKUP_IN_STORE_RADIO_BUTTON: '.js-pickup-in-store-radio',
    SHIPPING_OPTION_ADDRESS: '.js-address'
};

const classes = {
    PICKUP_IN_STORE_FLYOUT_CLASS: 'delivery-wide-flyout'
};

exports.updateShippingInformation = updateShippingInformation;
exports.initUpdatingShippingInformation = initUpdatingShippingInformation;
exports.initPickupEvents = initPickupEvents;


exports.init = function () {
    initGWPChoosingPopup();
    if ($('input[id$="sasEurobonusMember"]').is(':checked')) {
        $('.js-eurobonus-dropdown').removeClass('hide');
    }
    handleBillingAddressFields();
    handleNifNumberSection();

    // validate on keyup for fields with error
    $(document).on('keyup', '.js-step-1-content .error', function (e) {
        //get selection position
        const start = this.selectionStart,
            end = this.selectionEnd;

        if ($(this).data('prevent-automatic-validation')) {
            return;
        }

        $(e.target).valid();
        //set the range
        if ($(e.target).is(':not([type=email], [type=number])')){
            this.setSelectionRange(start, end);
        }
    });

    $(document).on('change', '.js_delivery_date_select :input', function() {
        const selectedOption = $('#dwfrm_singleshipping_deliveryOption option:selected');
        const shippingOptionId = selectedOption.data('shipping-option-id');
        const shippingService = selectedOption.data('shipping-service');
        updateShippingInformation(shippingOptionId, shippingService, null, null, function(response){
            $('.js-shipping-price').text(response.selectedShippingOption.shippingPrice);
            $('.js-order-value').text(response.selectedShippingOption.totalPrice);
            $('.js-checkout-sticky-bar .js-sticky-price-container .order-total-amount').text(response.selectedShippingOption.totalPrice);
        });
    });
};

exports.initGWPChoosingPopup = initGWPChoosingPopup;
exports.handleBillingAddressFields = handleBillingAddressFields;
exports.handleNifNumberSection = handleNifNumberSection;
exports.handleNifStep2 = handleNifStep2;

function getFlyoutForEditPickupPointsAndStores(selector, additionalClassToFlyout) {
    const $this = $(this);
    const options = getEditPickupPointsAndStoresDeliveryFlyoutOptions(additionalClassToFlyout);
    const flyoutHtml = $(selector).html();
    flyout.loadFromHtml(flyoutHtml, options);
    $this.addClass('js-triggered-flyout');
}

function initPickupEvents() {
    $(document).on('click', '.js-pickup-point-change', function (e) {
        e.preventDefault();

        const $postNummerEl = $(this).closest('.js-checkout-review-box').find('.js-service-point-postnummer-input');
        if ($postNummerEl.length > 0) {
            const postNummer = $postNummerEl.val().trim();
            $.ajax({
                type: 'GET',
                url: Urls.checkoutCheckAccountServiceNumberForPaazl,
                data: {
                    accountServiceNumber: postNummer
                },
                success: function (data) {
                    if (data.valid) {
                        $('#dhl-post-number-for-edit-pup').val(postNummer);
                        $('#dhl-post-number-display-string').val(data.displayDhlString);
                        getFlyoutForEditPickupPointsAndStores(selectors.PICKUP_POINT_WRAPPER);
                    } else {
                        $('.js-service-point-postnummer-input-error').removeClass('hide');
                    }
                }
            });
        } else {
            getFlyoutForEditPickupPointsAndStores(selectors.PICKUP_POINT_WRAPPER);
        }
    });

    $(document).on('keydown', '.js-service-point-postnummer-input', function(e) {
        if (e.which === 8 || e.which === 13 || e.which === 16 || e.which === 17 || e.which === 18) {
            return;
        }

        const errorSpan = $('.js-service-point-postnummer-input-error');
        if (!errorSpan.hasClass('hide')) {
            errorSpan.addClass('hide');
        }
    });

    $(document).on('click', '.js-pickup-in-store-change', function () {
        getFlyoutForEditPickupPointsAndStores(selectors.PICKUP_IN_STORE_FLYOUT_WRAPPER, classes.PICKUP_IN_STORE_FLYOUT_CLASS);
        if ($('#find-stores-postalcode-form',$(this))) {
            validatory.init();
            formHelper.initializeDataMask();
        }
    });

    $(document).on('click', '.js-select-pickup-radio:not(.selected)', function () {
        const $this = $(this);
        const $wrapper = $this.parents('.js-flyout-content');
        $('.js-select-pickup-radio.selected', $wrapper).removeClass('selected');
        $this.addClass('selected');
    });

    $(document).on('click', '.js-delivery-flyout-list-toggle', function () {
        const $this = $(this);
        if (!$this.hasClass('open')) {
            $('.js-delivery-flyout-list-toggle', '.js-flyout-content').removeClass('open');
            $('.delivery-flyout-list-details', '.js-flyout-content').stop().slideUp();
            $this.addClass('open');
            $this.parent().next('.delivery-flyout-list-details').stop().slideDown();
        } else {
            $this.removeClass('open');
            $this.parent().next('.delivery-flyout-list-details').stop().slideUp();
        }
    });

    $(document).on('click', '.js-pickup-in-store-see-more', function() {
        const $this = $(this);
        const storesToShow = $this.data('storesToShow');
        const $flyoutContent = $this.closest('.js-flyout-content');
        const $hiddenStores = $('.js-pickup-in-store-row.hide:lt(' + storesToShow + ')', $flyoutContent);
        $hiddenStores.removeClass('hide');
        const $hiddenStoresLeft = $('.js-pickup-in-store-row.hide', $flyoutContent);
        if (!$hiddenStoresLeft.length) {
            $this.remove();
        }
    });
}

function initUpdatingShippingInformation(callback) {
    $(document).on('click','.js-update-selected-pickup-point', function () {
        const page = $('.js-checkout-step-content').length ? 'checkout_page' : 'cart_page';
        const $this = $(this);

        const $flyoutContent = $this.closest('.js-flyout-content');
        const $selectedPickup = $('.js-select-pickup-radio.selected', $flyoutContent);

        if (!$selectedPickup.length) {
            return;
        }

        const shippingOptionId = $selectedPickup.data('shipping-option-id');
        const defaultOption = $selectedPickup.data('default-option');
        const pickupPointCode = $selectedPickup.data('service-point-code');
        const shippingService = $selectedPickup.data('shipping-service');

        const shippingDisplayValues = {
            dhlPostNummer: $('#dhl-post-number-for-edit-pup').length ? $('#dhl-post-number-for-edit-pup').val() : null,
            shippingPrice: $this.data('shipping-price'),
        };

        const $postalCodeForm = $('#find-pickup-postalcode-form', $flyoutContent);
        const postalCode = $postalCodeForm.length ? $postalCodeForm.data('current-postal-code') : null;

        const $currentlySelectedOption = page == 'checkout_page' ? $('.js-option-radio:checked', '.js-shipping-options-container') : null;

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $currentlySelectedOption, function() {
            updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, shippingDisplayValues.dhlPostNummer, function(response) {
                updatePickupPointShippingOption(response.selectedShippingOption, shippingDisplayValues, $flyoutContent);
            }, defaultOption, postalCode);
        });
    });

    function updatePickupPointShippingOption(selectedShippingOption, shippingDisplayValues, flyoutContent) {
        if (selectedShippingOption.isDHLPostNummerValid) {
            $('.js-dhl-post-nummer').val(shippingDisplayValues.dhlPostNummer);
        }

        const $destinationPickupPointItem = $('.js-pickup-option-label');
        $('.js-service-point-name', $destinationPickupPointItem).html(selectedShippingOption.name);
        $('.js-address', $destinationPickupPointItem).html(selectedShippingOption.address + ' ' + selectedShippingOption.city);
        $('.js-option-price', $destinationPickupPointItem).html(selectedShippingOption.shippingPrice);

        const $shippingOptionCheckbox = $('.js-option-radio[data-default-option="' + selectedShippingOption.shippingType + '"]');

        $shippingOptionCheckbox.data('service-point-code', selectedShippingOption.code);

        $('.js-edit-pickup-option-item.selected').removeClass('selected');
        $('.js-edit-pickup-option-item[data-pickup-point-code=' + selectedShippingOption.code + ']').addClass('selected');

        const $pickupPointFlyoutWrapper = $('.js-edit-pickup-points-wrapper');
        $pickupPointFlyoutWrapper.empty().html(flyoutContent.html());

        flyout.closeFlyouts();

        if ($shippingOptionCheckbox.length) {
            $shippingOptionCheckbox.prop('checked', true);
        }

        callback(selectedShippingOption);
    }

    $(document).on('click', '.js-update-selected-pickup-in-store', function() {
        const page = $('.js-checkout-step-content').length ? 'checkout_page' : 'cart_page';
        const $this = $(this);

        const $flyoutContent = $this.closest('.js-flyout-content');
        const $selectedStore = $('.js-select-pickup-radio.selected', $flyoutContent);
        if (!$selectedStore.length) {
            return;
        }

        const shippingOptionId = $selectedStore.data('shipping-option-id');
        const defaultOption = $selectedStore.data('default-option');
        const pickupPointCode = $selectedStore.data('service-point-code');
        const shippingService = $selectedStore.data('shipping-service');

        const shippingDisplayValues = {
            addressWithTime: $selectedStore.data('radioButtonAddressWithTime'),
            postalCode: $('#find-stores-postalcode-form', $flyoutContent).length ? $('#find-stores-postalcode-form', $flyoutContent).data('current-postal-code') : null
        };

        const $currentlySelectedOption = page == 'checkout_page' ? $('.js-option-radio:checked', '.js-shipping-options-container') : null;

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $currentlySelectedOption, function() {
            updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, null, function(response) {
                updatePickupInStoreShippingOption(response.selectedShippingOption, shippingDisplayValues, $flyoutContent);
            }, defaultOption, shippingDisplayValues.postalCode);
        });
    });

    function updatePickupInStoreShippingOption(selectedShippingOption, shippingDisplayValues, flyoutContent) {
        const $shippingOptionsContainer = $(selectors.SHIPPING_OPTIONS_CONTAINER);
        const $shippingOptionCheckbox = $('.js-option-radio[data-default-option="' + selectedShippingOption.shippingType + '"]');

        $shippingOptionCheckbox.data('servicePointCode', selectedShippingOption.code);

        const $pickupInStoreAddress = $(selectors.SHIPPING_OPTION_ADDRESS, $shippingOptionsContainer);
        $pickupInStoreAddress.find('strong').text(shippingDisplayValues.addressWithTime);

        const $pickupInStoreFlyoutWrapper = $(selectors.PICKUP_IN_STORE_FLYOUT_WRAPPER);
        $pickupInStoreFlyoutWrapper.empty().html(flyoutContent.html());

        flyout.closeFlyouts();

        if ($shippingOptionCheckbox.length) {
            $shippingOptionCheckbox.prop('checked', true);
        }
        callback(selectedShippingOption);
    }

    $(document).on('change', '.js-scheduled-home-delivery-select', function() {
        const page = $('.js-checkout-step-content').length ? 'checkout_page' : 'cart_page';
        if (page == 'checkout_page') {
            $('.js-shipping-option-radio-label').trigger('mousedown');
            $(document).trigger($.Event('checkout.onHomeDeliveryTimeChange'));
            return;
        }

        const $this = $(this);
        const $shippingOption = $('option:selected', $this);

        const shippingOptionId = $shippingOption.data('shipping-option-id');
        const shippingService = $shippingOption.data('shipping-service');
        const pickupPointCode = $shippingOption.data('service-point-code');
        const defaultOption = $shippingOption.data('default-option');

        const shippingDisplayValues = {
            displayName: $shippingOption.data('display-name'),
            displayTime: $shippingOption.data('display-time'),
            optionPrice: $shippingOption.data('shipping-formatted-price')
        };

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, null, function() {
            updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, null, function(response) {
                updateHomeDeliveryShippingOption(response.selectedShippingOption, shippingDisplayValues);
            }, defaultOption, null);
        });
    });

    function updateHomeDeliveryShippingOption(selectedShippingOption, shippingDisplayValues) {
        const $homeDeliveryWrapper = $('.js-home-delivery-wrapper');
        const $shippingOptionName = $('.js-option-title strong', $homeDeliveryWrapper);
        const $shippingOptionPrice = $('.js-delivery-option-price', $homeDeliveryWrapper);

        $shippingOptionName.text(shippingDisplayValues.displayName);
        $shippingOptionPrice.text(shippingDisplayValues.optionPrice);

        if (shippingDisplayValues.displayTime) {
            const $shippingOptionTime = $('.js-option-time', $homeDeliveryWrapper);
            $shippingOptionTime.text(shippingDisplayValues.displayTime);
        }

        const $shippingOptionCheckbox = $('.js-option-radio[data-default-option="' + selectedShippingOption.shippingType + '"]');
        $shippingOptionCheckbox.data('shipping-option-id', selectedShippingOption.id);

        if ($shippingOptionCheckbox.length) {
            $shippingOptionCheckbox.prop('checked', true);
        }

        callback(selectedShippingOption);
    }
}

function getEditPickupPointsAndStoresDeliveryFlyoutOptions(additionalClassForFlyout) {
    return {
        open: function() {
            adjustEditShippingFlyoutOnInit(additionalClassForFlyout);
            editShippingFlyoutAccessibilityAdjust();
        },
        close: function() {
            if (additionalClassForFlyout) {
                $(genericFlyout).removeClass(additionalClassForFlyout);
            }
            resetCloseFlyoutBtnPosition(additionalClassForFlyout);
        }
    };
}

function adjustEditShippingFlyoutOnInit(additionalClassForFlyout) {
    $(genericFlyout).addClass('delivery-wide-flyout');
    if (additionalClassForFlyout) {
        $(genericFlyout).addClass(additionalClassForFlyout);
    }
}

function editShippingFlyoutAccessibilityAdjust() {
    $(document).on('keydown', '.js-flyout-edit-shipping-options .js-postal-code, .js-flyout-edit-shipping-options .js-service-point-zipcode-input', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $(editShippingFlyoutCloseClass).focus();
        }
    });

    $(document).on('keydown', editShippingFlyoutCloseClass, function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();

            const $editShippingFlyout = $(genericFlyout).find(editShippingFlyoutClass);
            const $updateShippingOption = $editShippingFlyout.find('.js-update-shipping-option');
            const $updateSelectPickupPoint = $editShippingFlyout.find('.js-edit-pickup-option-item');

            if ($updateShippingOption.length) {
                $updateShippingOption.focus();
            } else if ($updateSelectPickupPoint.length) {
                $updateSelectPickupPoint.last().find('.js-select-pickup-radio').focus();
            }
        } else if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $(editShippingFlyoutClass).find('input').first().focus();
        } else if (e.which === 13) {
            e.preventDefault();
            flyout.closeFlyouts();
            resetCloseFlyoutBtnPosition();
        }
    });
}

function resetCloseFlyoutBtnPosition() {
    $(document).find('.js-triggered-flyout').focus();
}

function updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, dhlPostNummer, onUpdate, selectedFakeOption, postalCode) {
    $.ajax({
        type: 'POST',
        url: Urls.setCartShippingMethod,
        contentType: 'application/json',
        data: JSON.stringify({
            service: shippingService,
            optionId: shippingOptionId,
            pickupPointCode: pickupPointCode,
            dhlPostNummer: dhlPostNummer,
            selectedFakeOption: selectedFakeOption,
            postalCode: postalCode
        }),
        success: function(response) {
            if (onUpdate) {
                onUpdate(response);
            }
        }
    });
}

function initGWPChoosingPopup(){
    const nonSelectedGiftLink = $('.bonus-item-actions a.js-select-bonus-product').first();
    if (nonSelectedGiftLink && nonSelectedGiftLink.length > 0) {
        const bonusProductsView = require('../../bonus-products-view');
         bonusProductsView.show({
            url: nonSelectedGiftLink.attr('href'),
            giftChange: false,
            response: null,
            isAddedPopup: nonSelectedGiftLink.data('showadded'),
            checkout: !!nonSelectedGiftLink.data('oncheckout')
        });
     }
}

function handleBillingAddressFields(){
    const $billingAddressForm = $('.js-1st-step-billing');
    if (!$billingAddressForm.length) {
        return;
    }

    const $useAsBillingAddress = $('.js-checkout-form input[id$=useAsBillingAddress]');
    const $billingAddressToCollapse = $('.js-billing-address-collapse');

    if ($billingAddressForm.hasClass('pickup-point')) {
        $useAsBillingAddress.parents('.form-row').hide();
        $useAsBillingAddress.prop('checked', false);
        return;
    }

    if ($useAsBillingAddress.is(':checked')) {
        $billingAddressToCollapse.hide();
    }

    $useAsBillingAddress.on('change', function () {
        $billingAddressToCollapse.slideToggle(400);
    });
}

function handleNifNumberSection() {
    const forms = ['.js-shipping_address_form', '.js-billing-address-form'];

    forms.forEach(function(form) {
        const $formRow = $(form).find('input[id$=addNifNumber').closest('.form-row');
        const $inputCheckbox = $(form).find('input[id$=addNifNumber');
        const $numberFieldWrapper = $(form).find('input[id$=nifNumber]').parent();
        const $inputNumber = $(form).find('input[id$=nifNumber]');

        if (!$inputNumber.val()) {
            $numberFieldWrapper.css('display', 'none');
        } else {
            $inputCheckbox.prop('checked', true);
        }

        $formRow.off('click').on('click', function() {
            handleNifNumberActions($(this).closest('fieldset'));
        });
    });
}

function handleNifStep2() {
    const $form = $('.js-generic-flyout');
    $form.off('click').on('click', function(e) {
        const target = $(e.target);
        if (!target.closest('.form-row').find('input[id$=addNifNumber').length) {
            return;
        }

        handleNifNumberActions($(this));
    });
}

function handleNifNumberActions(element) {
    const $inputCheckbox = element.find('input[id$=addNifNumber]');
    const $numberFieldWrapper = element.find('input[id$=nifNumber]').parent();

    if ($inputCheckbox.is(':checked')) {
        $inputCheckbox.prop('checked', false);
        $numberFieldWrapper.css('display', 'none');
    } else {
        $inputCheckbox.prop('checked', true);
        $numberFieldWrapper.css('display', 'block');
    }
}
